<template>
  <v-card
    color="white"
    class="rounded-xl mt-5"
    v-if="currentClient"
    @click="openLink"
  >
    <v-card-text class="pb-0">
      <v-img
        class="mx-auto px-2"
        max-width="300"
        :src="require('@/assets/nexus-connect-logo.svg')"
      />
    </v-card-text>
    <v-card-subtitle class="text-center black--text">
      Scan Alignment Software
    </v-card-subtitle>
    <v-card-text class="text-center">
      <v-img
        class="mx-auto"
        :src="require('@/assets/nexus-analyzer-animation.gif')"
        max-width="300"
      />
      <v-btn text color="primary" class="mt-4">Validate Now</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import apiOptions from "@/plugins/axios/axios_options";

export default {
  name: "NexusConnect",
  computed: {
    ...mapGetters(["currentClient"]),
  },
  methods: {
    openLink() {
      window.open(apiOptions.analyzerURL, "_blank");
    },
  },
};
</script>
